import React, { useEffect, useRef, useState } from 'react'
import SectionHeader from '../molecules/SectionHeader'
import { markdownToJSX } from '../../util/transforms'
import { MEDIUM } from '../util/breakpoints' 
import { useMediaQuery } from "react-responsive";
import Video from "../atoms/Video"
import Image from "../atoms/Image"
import Link from "../atoms/Link"
import showModalGallery from "../organisms/ModalGallery"

export default ({ label, title, intro, alignText, gallery, link, translations }) => {

  const textCenter = alignText
  const gridRef = useRef( null )
  const isDesktop = useMediaQuery({ minWidth: MEDIUM })
  const [itemLinkClass, setItemLinkClass] = useState( "" )

  useEffect(()=>{
    setGridHeight()
    const instance = gridRef.current
    instance.addEventListener( 'click', onGridClick )
    return () => {
      instance.removeEventListener( 'click', onGridClick )
    }
  }, [])

  useEffect(()=>{
    window.addEventListener('resize', setGridHeight )
    return () => {
      window.removeEventListener('resize', setGridHeight )
    }
  })

  const setGridHeight = () => {
    let height = 0 
    if( !gridRef.current.children[0] ) {
      return
    }
    if( isDesktop ) {
      height = gridRef.current.children[0].offsetWidth * 0.88 // not exactly square
    } else {
      if( gridRef.current.children[0].offsetWidth < window.innerHeight ){
        height = ( gridRef.current.children[0].offsetWidth * 0.78 ) * 2 // a little less square
      } else {
        height = ( window.innerHeight * 0.78 ) * 2 // a little less square and device in landscape
      }
    }

    gridRef.current.style.height = Math.floor( height ) + 'px'
  }

  const onGridClick = (e) => {
    e.preventDefault()
    if( e.target.className.indexOf( 'o-media-grid__item' ) > -1 && link  ) {
      showModalGallery({ gallery: link.gallery, translations: translations })
    }
  }

  return (
    <section className={ 'u-section-spacing' }>
      <SectionHeader title={ markdownToJSX(title) } label={ label } paragraph={ intro } isCentred={ textCenter } wide={ !textCenter }/>      
      <div className={"o-media-grid u-container" + ( !link ? " not-linked" : "" )}>
        <div className="o-media-grid__items" ref={ gridRef }>
          { (gallery && gallery.items) &&
            gallery.items.slice(0,4).map((item, index) =>
              <div className={`o-media-grid__item o-media-grid__item--${index+1}`} key={ index }>

                { item.file.contentType.substr(0, 5) == "video" &&
                  <Video src={ item.file.url } 
                    className="u-object-fit__media"
                    muted
                    playButton={true}
                  />
                }

                { item.file.contentType.substr(0, 5) == "image" &&
                  <Image className="u-object-fit__media" image={ item }/>
                }

              </div>
            )
          }
        </div>
      </div>
      { link &&
        <div className="u-center-text o-media-grid__link">          
          <Link link={ link } translations={ translations }/>
        </div>
      }
    </section>
  )

}